// extracted by mini-css-extract-plugin
module.exports = {"exhaustion":"CharacterSheetConditions_exhaustion_3-isb"};